

















































import Vue from "vue";

export default Vue.extend({
  name: "winningtable",
  components: {},
  props: {
    bet: String,
  },
  data: () => ({}),
  methods: {}
});
